import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { getModuleRoles } from "@/api/moduleRole.service";
import { UserRoles } from "@/api/user.service";
import { ESCALA_ROLES, MODULE_ID } from "@/api/escala.service";

const ADMINISTRADOR_DE_ESCALA = ESCALA_ROLES[2];

// Diz se o usuário logado administra a Escala do client atual: admin da plataforma ou
// "Administrador de Escala". É o que libera Cargas Horárias, Prazos, Parâmetros e Permissões — o
// backend recusa os quatro para os demais papéis. Falha na consulta conta como "não", só esconde as abas.
export function useAdministradorEscala(): { administrador: boolean; carregando: boolean } {
  const { user } = useAuth();
  const userId = user!.id;
  const clientId = user!.loggedClient!.id;
  const adminDaPlataforma = user!.role === UserRoles.Admin;
  const [administrador, setAdministrador] = useState(false);
  const [carregando, setCarregando] = useState(!adminDaPlataforma);

  useEffect(() => {
    if (adminDaPlataforma) return;
    let cancelado = false;
    setCarregando(true);
    getModuleRoles(userId, clientId, MODULE_ID)
      .then(({ roles }) => !cancelado && setAdministrador((roles ?? []).includes(ADMINISTRADOR_DE_ESCALA)))
      .catch(() => !cancelado && setAdministrador(false))
      .finally(() => !cancelado && setCarregando(false));
    return () => {
      cancelado = true;
    };
  }, [adminDaPlataforma, clientId, userId]);

  return { administrador: adminDaPlataforma || administrador, carregando };
}
